import { convertDecimalDosage } from "./utils";

const englishTranslations = {
  instructions: {
    everyday: "Everyday",
    "once a week": "Once a week",
    "twice a week": "Twice a week",
    "thrice a week": "Thrice a week",
    "four times a week": "Four times a week",
    "five times a week": "Five times a week",
    "six times a week": "Six times a week",
    sos: "SOS",
    "alternate days": "Alternate days",
    "once a month": "Once a month",
    "monday and thursday": "Monday and Thursday",
    "monday to friday": "Monday to Friday",
    "four times a day": "Four times a day",
    "saturday and sunday": "Saturday and Sunday",
    "tuesday to friday": "Tuesday to Friday",
    monday: "Monday",
    saturday: "Saturday",
    sunday: "Sunday",
    "before food": "Before Food",
    "after food": "After Food",
    "with food": "With Food",
    bedtime: "Bedtime",
    "empty stomach": "Empty Stomach",
  },
  durationUnits: {
    day: "Day",
    week: "Week",
    month: "Month",
    days: "Days",
    weeks: "Weeks",
    months: "Months",
  },
  dosage: {
    morning: "Morning",
    afternoon: "Afternoon",
    evening: "Evening",
    night: "Night",
  },
  headings: {
    "drug name": "Drug Name",
    strength: "Strength",
    dosage: "Dosage",
    instructions: "Instructions",
  },
  numbers: {
    0: "0",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    "1/2": "1/2",
  },
  titles: {
    Patient: "Patient",
    PRN: "PRN",
    "Consult Date": "Consult Date",
    "Consult Type": "Consult Type",
    Complaints: "Complaints",
    Notes: "Notes",
    Diagnosis: "Diagnosis",
    "Recommended Follow Up": "Recommended Follow Up",
    "Advised Pathology Tests": "Advised Pathology Tests",
    "Advised Radiology Tests": "Advised Radiology Tests",
    "Special Advice": "Special Advice",
    "Special Instructions": "Special Instructions",
    PrescribedBy: "Prescribed by ",

    "Reg no.": "Reg no.",
  },
  doctorNames: {
    DR000001: "Dr. Shashank Akerkar",
    DR000003: "Dr. Deepak Malgute",
    DR000004: "Dr. Archana Sonawale",
    DR000005: "Dr. Aarti Zope",
    DR000007: "Dr. Prashant N. Chhajed",
    DR000008: "Dr. Richa Gupta",
    DR000009: "Dr. Riya Shah",
    DR000010: "Dr. Sachin K Katarkar",
    DR000011: "Dr. Aarti Zope",
    DR000012: "Dr. G Manoj",
    DR000013: "Dr. Harshil Vora",
    DR000014: "Dr. Ankur Doshi",
    DR000015: "Dr. Nilesh Nolkha",
    DR000016: "Dr. Reena Karkhele Jaybhaye",
    DR000017: "Dr. Chitranjan Das",
    DR000018: "Dr. Puneet Mashru",
    DR000019: "Dr. Smruti S Ramteke",
    DR000020: "Dr. Kailash Kothari",
    DR000021: "Dr. Narendra Vadlamudi",
    DR000022: "Dr. Ujwala Kale",
    DR000023: "Dr. Vrushal Umesh Kale",
    DR000024: "Dr. Sanjay Ramteke",
    DR000025: "Dr. Smruti Ramteke",
    DR000026: "Dr. Pranit Khandait",
    DR000027: "Dr. Ketki Ambulkar Telang",
  },
};

export const prescriptionTranslations = {
  en: englishTranslations,
  "en-GB": englishTranslations,
  hi: {
    instructions: {
      everyday: "प्रतिदिन",
      "once a week": "हफ़्ते में एक बार",
      "twice a week": "हफ्ते में दो बार",
      "thrice a week": "हफ्ते में तीन बार",
      "four times a week": "हफ्ते में चार बार",
      "five times a week": "हफ्ते में पांच बार",
      "six times a week": "हफ्ते में छह बार",
      sos: "जरुरत के अनुसार",
      "alternate days": "एक दिन छोड़कर",
      "once a month": "महीने में एक बार",
      "monday and thursday": "सोमवार और गुरुवार",
      "monday to friday": "सोमवार से शुक्रवार तक",
      "four times a day": "एक दिन में चार बार",
      "saturday and sunday": "शनिवार और रविवार",
      "tuesday to friday": "मंगलवार से शुक्रवार तक",
      monday: "सोमवार",
      saturday: "शनिवार",
      sunday: "रविवार",
      "before food": "खाना खाने से पहले",
      "after food": "खाना खाने के बाद",
      "with food": "खाने के साथ",
      bedtime: "सोने के समय",
      "empty stomach": "खाली पेट",
    },
    durationUnits: {
      day: "दिन",
      week: "हफ़्ता",
      month: "महीना",
      days: "दिन",
      weeks: "हफ़्ते",
      months: "महीने",
    },
    dosage: {
      morning: "सुबह",
      afternoon: "दोपहर",
      evening: "शाम",
      night: "रात",
    },
    headings: {
      "drug name": "दवाई का नाम",
      strength: "ताकत",
      dosage: "डोज़",
      instructions: "सूचना",
    },
    numbers: {
      0: "०",
      1: "१",
      2: "२",
      3: "३",
      4: "४",
      5: "५",
      6: "६",
      7: "७",
      8: "८",
      9: "९",
      "1/2": "१/२",
    },
    titles: {
      Patient: "रुग्ण का नाम ",
      PRN: "पी आर एन",
      "Consult Date": "नियुक्ति की तारीख",
      "Consult Type": "नियुक्ति का तरीका",
      Complaints: "रुग्ण की शिकायत",
      Notes: "टिप्पणियाँ",
      Diagnosis: "रोगनिर्णय",
      "Recommended Follow Up": "अगली नियुक्ति की तारीख",
      "Advised Pathology Tests": "रक्त परीक्षण",
      "Advised Radiology Tests": "रेडियोलॉजी परीक्षण",
      "Special Advice": "विशेष सलाह",
      "Special Instructions": "विशेष सूचना",
      PrescribedBy: "निर्धारित",

      "Reg no.": "रजिस्ट्री क्रमांक",
    },
    doctorNames: {
      DR000001: "डॉ.शशांक आकेरकर",
      DR000003: "डॉ. दीपक मालगुटे",
      DR000004: "डॉ. अर्चना सोनावले",
      DR000005: "डॉ.आरती झोपे",

      DR000011: "डॉ.आरती झोपे",

      DR000013: "डॉ. हर्षिल वोरा",
      DR000014: "डॉ. अंकुर दोषी",
      DR000015: "डॉ. निलेश नोलखा",
      DR000016: "डॉ. रीना कारखेले जयभये",
      DR000017: "डॉ. चित्रंजन दास",
      DR000018: "डॉ. पुनीत मशरू",
      DR000019: "डॉ. स्मृति एस रामटेक",
      DR000020: "डॉ. कैलाश कोठारी",
      DR000021: "डॉ. नरेंद्र वडलमूदि",
      DR000022: "डॉ. उज्वला काले",
      DR000023: "डॉ. वृषल उमेश काले",
      DR000024: "डॉ. संजय रामटेके",
      DR000025: "डॉ. स्मृति रामटेके",
      DR000026: "डॉ. प्रणित खंडाईत",
      DR000027: "डॉ. केतकी अंबुलकर तेलंग",
    },
  },
  mr: {
    instructions: {
      everyday: "दररोज",
      "once a week": "आठवड्यातून एकदा",
      "twice a week": "आठवड्यातून दोनदा",
      "thrice a week": "आठवड्यातून तिनदा",
      "four times a week": "आठवड्यातून चार वेळा",
      "five times a week": "आठवड्यातून पाच वेळा",
      "six times a week": "आठवड्यातून सहा वेळा",
      sos: "आवश्यक असल्यास",
      "alternate days": "एक दिवस सोडून",
      "once a month": "महिन्यातून एकदा",
      "monday and thursday": "सोमवार आणि गुरुवार",
      "monday to friday": "सोमवार ते शुक्रवार",
      "four times a day": "दिवसातून चार वेळा",
      "saturday and sunday": "शनिवार आणि रविवार",
      "tuesday to friday": "मंगळवार ते शुक्रवार",
      monday: "सोमवार",
      saturday: "शनिवार",
      sunday: "रविवार",
      "before food": "खाण्याआधी",
      "after food": "खाल्ल्यानंतर",
      "with food": "अन्नासह",
      bedtime: "झोपण्याच्या वेळी",
      "empty stomach": "रिकाम्या पोटी",
    },
    durationUnits: {
      day: "दिवस",
      week: "आठवडा",
      month: "महिना",
      days: "दिवस",
      weeks: "आठवडे",
      months: "महिने",
    },
    dosage: {
      morning: "सकाळी",
      afternoon: "दुपारी",
      evening: "संध्या",
      night: "रात्रि",
    },
    headings: {
      "drug name": "औषधाचे नाव",
      strength: "शक्ती",
      dosage: "डोस",
      instructions: "सूचना",
    },

    numbers: {
      0: "०",
      1: "१",
      2: "२",
      3: "३",
      4: "४",
      5: "५",
      6: "६",
      7: "७",
      8: "८",
      9: "९",
      "1/2": "१/२",
    },

    titles: {
      Patient: "रुग्णाचे नाव",
      PRN: "पी आर एन",
      "Consult Date": "नियुक्तीची तारीख",
      "Consult Type": "नियुक्तीची पद्धत",
      Complaints: "रुग्णाची तक्रार",
      Notes: "नोट्स",
      Diagnosis: "रोगचिकित्सा",
      "Recommended Follow Up": "पुढील नियुक्तीची तारीख",
      "Advised Pathology Tests": "रक्त चाचणी",
      "Advised Radiology Tests": "रेडिओलॉजी चाचणी",
      "Special Advice": "विशेष सल्ला",
      "Special Instructions": "विशेष सूचना",
      PrescribedBy: "ठरवले",

      "Reg no.": "नोंदणी क्र.",
    },
    doctorNames: {
      DR000001: "डॉ.शशांक आकेरकर",
      DR000003: "डॉ. दीपक मालगुटे",
      DR000004: "डॉ. अर्चना सोनावले",
      DR000005: "डॉ.आरती झोपे",

      DR000011: "डॉ.आरती झोपे",

      DR000013: "डॉ. हर्षिल वोरा",
      DR000014: "डॉ. अंकुर दोषी",
      DR000015: "डॉ. निलेश नोलखा",
      DR000016: "डॉ. रीना कारखेले जयभये",
      DR000017: "डॉ. चित्रंजन दास",
      DR000018: "डॉ. पुनीत मशरू",
      DR000019: "डॉ. स्मृति एस रामटेक",
      DR000020: "डॉ. कैलाश कोठारी",
      DR000021: "डॉ. नरेंद्र वडलमुडी",
      DR000022: "डॉ. उज्वला काले",
      DR000023: "डॉ. वृषल उमेश काले",
      DR000024: "डॉ. संजय रामटेके",
      DR000025: "डॉ. स्मृती रामटेके",
      DR000026: "डॉ. प्रणीत खंडाईत",
      DR000027: "डॉ. केतकी अंबुलकर तेलंग",
    },
  },
};

export function getTranslatedInstructions(instructionsText, lang = "en") {
  const phrases = Object.keys(prescriptionTranslations[lang].instructions);
  let translatedString = instructionsText;
  phrases.forEach((phrase) => {
    const regex = new RegExp(`\\b${phrase}\\b`, "gi"); // Match whole phrases
    if (regex.test(translatedString)) {
      translatedString = translatedString.replace(
        regex,
        prescriptionTranslations[lang]["instructions"][phrase]
      );
    }
  });
  return translatedString;
}

export function getTranslatedDosageHeader(dosageHeader, lang = "en") {
  return (
    prescriptionTranslations[lang].dosage[dosageHeader.toLowerCase()] ||
    dosageHeader
  );
}

export function getTranslatedDurationUnit(durationUnit, lang = "en") {
  return (
    prescriptionTranslations[lang].durationUnits[durationUnit.toLowerCase()] ||
    durationUnit
  );
}

export function getTranslatedDuration(durationText, lang = "en") {
  const durationSplittedArray = durationText.split(" ");
  const durationValue = durationSplittedArray[0];
  const durationUnit = durationSplittedArray[1];

  return `${getTranslatedPrescriptionNumbers(
    durationValue,
    lang
  )} ${getTranslatedDurationUnit(durationUnit, lang)}`;
}

export function getTranslatedPrescriptionHeaderText(
  prescriptionHeaderText,
  lang = "en"
) {
  return (
    prescriptionTranslations[lang].headings[
      prescriptionHeaderText.toLowerCase()
    ] || prescriptionHeaderText
  );
}

export function getTranslatedPrescribedBySentence(lang) {
  return prescriptionTranslations[lang].titles["PrescribedBy"];
}

export function getTranslatedPrescriptionDoctorName(doctorId, lang = "en") {
  console.log(doctorId, lang, "drName");
  return prescriptionTranslations[lang].doctorNames[doctorId] || "";
}

export function isSupportedLanguage(languageValue) {
  return Object.keys(prescriptionTranslations).includes(languageValue);
}

export function isDevanagariScriptLanguage(lang) {
  const devanagarianguageList = ["hi", "mr"];
  return devanagarianguageList.includes(lang);
}

export function isTextInDevanagari(text) {
  const devanagariRegex = /[\u0900-\u097F]/;
  return devanagariRegex.test(text);
}

export function getTranslatedPrescriptionTitleText(
  prescriptionTitleText,
  lang = "en"
) {
  return (
    prescriptionTranslations[lang].titles[prescriptionTitleText] ||
    prescriptionTitleText
  );
}

export function getTranslatedPrescriptionNumbers(number, lang = "en") {
  if (number == null) return number; // Handle null/undefined cases

  // Convert decimal numbers like 7.5 → "7½"
  let formattedNumber = convertDecimalDosage(parseFloat(number));

  // Split into individual digits and translate each one
  return formattedNumber
    .split("")
    .map((char) => prescriptionTranslations[lang].numbers[char] || char)
    .join("");
}
